export default "__VITE_ASSET__Ct3npFR8__"